import React, {useState, useEffect, useRef} from "react";

export const POSITION = {
    TOP: 'top',
    BOTTOM: 'bottom'
}

const StickyBlock = props => {
    const {className, scrollElement = document, position = POSITION.TOP, children, ...other} = props;
    const [isSticky, setIsSticky] = useState(false);
    const stickyRef = useRef();

    const handleScroll = () => {
        if (stickyRef.current) {
            const {top, bottom} = stickyRef.current.getBoundingClientRect();
            const scrollTop = scrollElement.scrollTop;
            const scrollHeight = scrollElement.scrollHeight;
            const clientHeight = scrollElement.clientHeight;

            const parent = stickyRef.current.parentElement;
            const parentStyle = window.getComputedStyle(parent);
            const parentPaddingTop = parseFloat(parentStyle.paddingTop);
            const parentPaddingBottom = parseFloat(parentStyle.paddingBottom);

            let offset;
            if (position === POSITION.TOP) {
                offset = top - scrollTop - parentPaddingTop;
            } else {
                const scrollBottomPosition = scrollHeight - clientHeight;
                offset = bottom - scrollBottomPosition + parentPaddingBottom;
            }

            if (position === POSITION.TOP) {
                setIsSticky(offset < 0);
            } else {
                setIsSticky(offset >= 0);
            }
        }
    }

    useEffect(() => {
        scrollElement.addEventListener('scroll', handleScroll);
        return () => {
            scrollElement.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div
            ref={stickyRef}
            className={"ch-sticky" + (position === POSITION.BOTTOM ? ' ch-sticky-bottom' : '') + (className ? ' ' + className : '')}
            {...other}
        >
            {children}
        </div>
    )
}

export default StickyBlock;